import { format } from 'date-fns';
import type { DateRange } from 'react-day-picker';

const MANILA_OFFSET = '+08:00';

function padDatePart(value: number): string {
  return String(value).padStart(2, '0');
}

function parseManilaIsoDate(value?: string): Date | undefined {
  if (!value) return undefined;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return undefined;
  const [, year, month, day] = match;
  const parsed = new Date(Number(year), Number(month) - 1, Number(day));
  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.getFullYear() !== Number(year) ||
    parsed.getMonth() !== Number(month) - 1 ||
    parsed.getDate() !== Number(day)
  ) {
    return undefined;
  }
  return parsed;
}

export function getCustomDateRangeFromIso(from?: string, to?: string): DateRange | undefined {
  const fromDate = parseManilaIsoDate(from);
  const toDate = parseManilaIsoDate(to);
  if (!fromDate && !toDate) return undefined;
  return {
    from: fromDate ?? toDate,
    to: toDate ?? fromDate,
  };
}

export function toManilaDayBoundaryIso(date: Date, boundary: 'start' | 'end'): string {
  const year = date.getFullYear();
  const month = padDatePart(date.getMonth() + 1);
  const day = padDatePart(date.getDate());
  const time = boundary === 'start' ? '00:00:00' : '23:59:59';
  return `${year}-${month}-${day}T${time}${MANILA_OFFSET}`;
}

export function formatCustomDateRangeButton(range?: DateRange): string {
  if (!range?.from) return 'Pick a date';
  if (!range.to) return format(range.from, 'LLL dd, y');
  return `${format(range.from, 'LLL dd, y')} - ${format(range.to, 'LLL dd, y')}`;
}
